import {takeEvery} from 'redux-saga';
import {call, put} from 'redux-saga/effects';
import {appError} from './Status';

const GET_CONTEXTUAL_LISTS = 'app-qa/contextual/GET_CONTEXTUAL_LISTS';
export const getContextualLists = (lists, context) =>
  ({type: GET_CONTEXTUAL_LISTS, lists, context});

const GET_CONTEXTUAL_LISTS_SUCCESS = 'app-qa/contextual/GET_CONTEXTUAL_LISTS_SUCCESS';
export const getContextualListsSuccess = (lists, response, context) => ({type: GET_CONTEXTUAL_LISTS_SUCCESS, lists, response, context});

const CLEAR_CONTEXTUAL = 'app-qa/contextual/CLEAR_CONTEXTUAL';
export const clearContextual = () =>
  ({type: CLEAR_CONTEXTUAL});

export const actions = {
  GET_CONTEXTUAL_LISTS,
  GET_CONTEXTUAL_LISTS_SUCCESS,
  CLEAR_CONTEXTUAL,
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case GET_CONTEXTUAL_LISTS_SUCCESS: {
      const lists = action.lists;
      const response = action.response;
      const context = action.context;
      const contextualState = {};
      lists.forEach((list, index) => {
        if (list.name === 'most-popular-tags') {
          contextualState[list.name] = (response[index] && response[index].result) || [];
        }
        contextualState[list.name] = (response[index] && response[index].result) || [];
      });
      if (global.TES) {
        global.TES.events.trigger('showContextual', contextualState);
      }
      contextualState.contextType = context;
      return contextualState;
    }
    case CLEAR_CONTEXTUAL: {
      const contextualState = {};
      if (global.TES) {
        global.TES.events.trigger('showContextual', contextualState);
      }
      return contextualState;
    }
    default:
      return state;
  }
}

export function sagas({qaClient}) {
  function *getContextualListsSaga({lists, context}) {
    try {
      const response = yield lists.map((list) => {
        if (list.name === 'most-popular-tags') {
          return call(() => qaClient.getMostPopularTags(context));
        }
        return call(() => qaClient.getQuestions(list.order, list.tag, context, 0, 5, true, list.showUnanswered));
      });
      yield put(getContextualListsSuccess(lists, response, context));
    } catch (err) {
      yield put(appError({err}));
    }
  }

  return {
    *watchContextualListsSaga() { yield* takeEvery(GET_CONTEXTUAL_LISTS, getContextualListsSaga); },
  };
}
